import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import LocaleLink from './LocaleLink';
import LocaleBlock from './LocaleBlock';
import { breakpoints } from '../styles/Variables';

const CarouselStyles = styled.div`
  background-color: var(--tanLight);
  padding-top: 2rem;
  text-align: center;

  h3 {
    padding: 1em var(--col1);

    @media (min-width: ${breakpoints.breakLg}) {
      padding-bottom: 2em;
    }
  }

  .content {
    overflow-x: auto;
  }

  .propertiesWrapper {
    display: flex;

    .property {
      width: var(--col8);
      max-width: 26rem;
      padding-right: var(--col1);
      flex-shrink: 0;

      &:first-child {
        margin-left: var(--col2);
      }

      .gatsby-image-wrapper {
        height: 42vw;
        margin-bottom: 2rem;
      }

      .block {
        margin-bottom: 3rem;
      }

      p {
        margin-top: 0;
      }

      a {
        text-transform: uppercase;
        font-family: 'Caslon', sans-serif;
      }
    }

    p:not(:first-of-type) {
      display: none;
    }

    @media (min-width: ${breakpoints.breakLg}) {
      padding-left: var(--col1);
      padding-right: var(--col1);
      justify-content: center;

      .property {
        width: var(--col3);
        flex-grow: 1;
        margin-left: 2rem;
        padding-right: 0;

        &:first-child {
          margin-left: 0;
        }

        a {
          font-size: var(--fsTitle2);
        }

        .gatsby-image-wrapper {
          height: 20vw;
          margin-bottom: 2rem;
        }
      }
    }
  }
`;

export default function PropertiesCarousel({
  pages,
  showPageType,
  parentPageSlug,
  className,
  title,
}) {
  let filteredProperties = pages.nodes.filter(
    // List properties of this type, but not current one
    (aPage) => showPageType === aPage.type && parentPageSlug !== aPage.slug
  );
  if (filteredProperties.length < 3) {
    filteredProperties = pages.nodes.filter(
      // If there are fewer than three of this type, don't filter by type
      (aPage) => parentPageSlug !== aPage.slug
    );
  }
  // Show first three only
  const firstThree = filteredProperties.slice(0, 3);

  return (
    <CarouselStyles className={`propertiesCarousel ${className || ''}`}>
      <h3>{title}</h3>
      <div className="content">
        <div className="propertiesWrapper">
          {firstThree.map((aPage) => (
            <div className="property" key={aPage.slug}>
              <LocaleLink to={`/${aPage.slug}`}>
                <Img fluid={aPage.image.asset.fluid} alt={aPage.name} />
                {aPage.name}
              </LocaleLink>
              <LocaleBlock content={aPage._rawIntroduction} />
            </div>
          ))}
        </div>
      </div>
    </CarouselStyles>
  );
}
